import React, { FunctionComponent } from 'react';
import moment from 'moment';
import { Message } from 'semantic-ui-react';
import { Dealer } from '@upstart/harmony/lib/legos/dealerTypes';
import { TableTitle } from '../TableTitle/TableTitle';
import LoadingOverlay from '../../components/LoadingOverlay';

interface Props {
  dealersList: Array<Dealer>;
  isFetching: boolean;
  sortBy: Function;
  renderStatus: Function;
  searchTerm: string;
  groupsMap: {
    [index: string]: string | null | undefined;
  };
}

const LendingStatusTable: FunctionComponent<Props> = ({
  dealersList,
  isFetching,
  sortBy,
  renderStatus,
  searchTerm,
  groupsMap,
}) => {
  const statusDotColor = (status: string) =>
    status === 'Yes' ? '#0bca58' : '#ee2430';

  const renderRow = (dealer: Dealer) => {
    const email = dealer.launchpad?.email || '';
    const firstLogin = dealer.launchpad?.firstLogin || '';
    const lendingStatus =
      dealer.lending?.online?.enabled || dealer.lending?.instore?.enabled
        ? 'Yes'
        : 'No';

    const upstLoanStatus = dealer.lending?.upstart?.enabled ? 'Yes' : 'No';
    const { label: statusLabel, color: statusColor } = renderStatus(dealer);
    return (
      <div className="lending-status-list-table-row" key={dealer.id}>
        <div>{dealer.name}</div>
        <div>
          {dealer.dealergroup_id ? groupsMap[dealer.dealergroup_id] : ''}
        </div>
        <div>{email}</div>
        <div>
          {firstLogin ? moment(firstLogin).format('MM/DD/YYYY') : 'N/A'}
        </div>
        <div className="dealer-list-lending-status">
          <div
            className="status-dot"
            style={{ backgroundColor: statusDotColor(lendingStatus) }}
          />
          {lendingStatus}
        </div>
        <div className="dealer-list-upstart-loans">
          <div
            className="status-dot"
            style={{ backgroundColor: statusDotColor(upstLoanStatus) }}
          />
          {upstLoanStatus}
        </div>
        <div className="dealer-list-status">
          {statusColor && (
            <div
              className="status-dot"
              style={{ backgroundColor: statusColor || '' }}
            />
          )}
          {statusLabel}
        </div>
      </div>
    );
  };

  return (
    <div className="lending-status-list-container">
      <div className="lending-status-list-table-container">
        <div className="lending-status-list-table-header">
          <TableTitle title="Dealer Name" sortable onClick={sortBy('name')} />
          <TableTitle title="Group" sortable onClick={sortBy('group')} />
          <TableTitle
            title="Email"
            sortable
            onClick={sortBy('launchpad.email')}
          />
          <TableTitle
            title="First Login"
            sortable
            onClick={sortBy('launchpad.firstLogin')}
          />
          <TableTitle
            title="Lending"
            sortable
            onClick={sortBy('lendingStatus')}
          />
          <TableTitle
            title="Upstart Loans"
            sortable
            onClick={sortBy('upstartloans')}
          />
          <TableTitle
            title="Launch Status"
            sortable
            onClick={sortBy('obtainStatus')}
          />
        </div>
        <LoadingOverlay active={isFetching}>
          <div className="lending-status-list-table-body">
            {dealersList.map((dealer) => renderRow(dealer))}
            {dealersList &&
              dealersList.length === 0 &&
              !isFetching &&
              searchTerm && (
                <Message>
                  <Message.Header>No dealer matches the filter</Message.Header>
                </Message>
              )}
          </div>
        </LoadingOverlay>
      </div>
    </div>
  );
};

export default LendingStatusTable;
